import { AllTrafficChannelsOverviewBarChartContainer } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/AllTrafficChannelsOverviewBarChartContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOAllTrafficChannelsOverviewBarChartContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("accountreview_website_marketingchannels", params),
            target: "_self",
        };
    };
    return (
        <AllTrafficChannelsOverviewBarChartContainer
            getCtaLink={getCtaLink}
            isWWO={true}
            unlockHook={{
                component: "WsWebTrafficChannels",
                hookModal: "WebTrafficChannelsFeature",
            }}
            hideFooter={hideFooter}
        />
    );
};
